import React from 'react';

import Button from 'shared/button';
import { buildGrantUrl } from './helpers';

import type { Grant } from '../types';

interface Props {
  path: string;
  grant: Grant;
  scopes?: string[];
}

export default function ExpiredNylasGrant({ grant, path, scopes }: Props) {
  return (
    <div className="d-flex align-items-center">
      <div className="mr-4">The connection to {grant.email} via {grant.provider} has expired</div>
      <Button.Primary
        label="Reconnect"
        onClick={() => window.location.assign(buildGrantUrl(path, scopes))}
      />
    </div>
  );
}
